import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23c16371"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "topbox" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "先锋云信，探索更多成功的可能！", -1))
const _hoisted_4 = { class: "bottombox" }
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = { class: "example" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "产品", -1))
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "example" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "价格")
], -1))
const _hoisted_10 = { class: "example" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "解决方案", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"example\" data-v-23c16371><span class=\"title\" data-v-23c16371>下载中心</span></div><div class=\"example\" data-v-23c16371><span class=\"title\" data-v-23c16371>联系我们</span></div><div class=\"contactus\" data-v-23c16371><span class=\"concern\" data-v-23c16371>关注或联系我们</span><span class=\"phone\" data-v-23c16371>联系人电话： 139-xxxx-xxxx</span><img class=\"code\" src=\"/assets/code.png\" alt=\"\" data-v-23c16371></div>", 3)
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filings" }, [
  /*#__PURE__*/_createTextVNode(" ©2024-2026 成都同村科技有限公司 "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://beian.miit.gov.cn/#/Integrated/index"
  }, "蜀ICP备2024056584号")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "contacttitle",
        to: "/contact"
      }, {
        default: _withCtx(() => [
          _createTextVNode("联系我们")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "href",
              to: "/aboutXf"
            }, {
              default: _withCtx(() => [
                _createTextVNode("先锋云信")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "href",
              to: "/aboutLiveMeeting"
            }, {
              default: _withCtx(() => [
                _createTextVNode("视频会议")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "href",
              to: "/solution"
            }, {
              default: _withCtx(() => [
                _createTextVNode("行业方案")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "href",
              to: "/solution"
            }, {
              default: _withCtx(() => [
                _createTextVNode("典型案例")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_13
      ]),
      _hoisted_16
    ])
  ]))
}